module.exports = __webpack_public_path__ + "static/media/BIOS.cc5750f4.png";